import { LanguagesIcon } from "lucide-react";
import { languageLabel } from "./labels";

interface LanguageColumnCellProps {
  langIso?: string;
}

// Mirrors GenderColumnCell: icon + label, dash when the corpus has no language.
export default function LanguageColumnCell({ langIso }: LanguageColumnCellProps) {
  const code = (langIso ?? "").trim().toLowerCase();
  if (!code) {
    return <div className="text-[13px] pr-2 text-muted-foreground">-</div>;
  }
  return (
    <div className="flex flex-row items-center gap-1.5 text-[13px] pr-2" title={code}>
      <LanguagesIcon className="size-3.75 shrink-0 text-muted-foreground" aria-hidden="true" />
      <span className="truncate leading-5">{languageLabel(code)}</span>
    </div>
  );
}
